import { render, staticRenderFns } from "./GiftMultiple.vue?vue&type=template&id=79eec152&scoped=true&"
import script from "./GiftMultiple.vue?vue&type=script&lang=js&"
export * from "./GiftMultiple.vue?vue&type=script&lang=js&"
import style0 from "./GiftMultiple.vue?vue&type=style&index=0&id=79eec152&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eec152",
  null
  
)

export default component.exports